const languages = [
  {
    label: '简体中文',
    value: 'zh'
  },{
    label: '繁体中文',
    value: 'tw'
  },{
    label: 'English',
    value: 'en'
  },{
    label: 'Indonesia',
    value: 'id'
  },{
    label: 'ไทย',
    value: 'th'
  },{
    label: 'Espanol',
    value: 'es'
  }
]

export { languages }